import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function SectionButtons() {
    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);

    const [paddingSide, setPaddingSide] = useState(0);
    const [paddingBox, setPaddingBox] = useState(0);

    const [paddingX, setPaddingX] = useState(0);
    const [paddingY, setPaddingY] = useState(0);

    const pageType = useSelector((state) => state.storefront.pageType);
    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    useEffect(() => {
        setTextSize((zoomSize/100)*14);
        setLineHeight((zoomSize/100)*24);
        setPaddingSide((zoomSize/100)*16);
        setPaddingBox((zoomSize/100)*4);

        setPaddingX((zoomSize/100)*24);
        setPaddingY((zoomSize/100)*8);
    }, [zoomSize]);

    return (
        <div style={{ fontSize: `${textSize}px`, lineHeight: `${lineHeight}px`, paddingLeft: `${paddingSide}px`, paddingRight: `${paddingSide}px` }} className="flex w-full font-medium bg-[#FFFFFF] select-none">
            <div style={{ padding: `${paddingBox}px` }} className="w-full flex bg-[#FFFFFF78]">
                <div style={{ paddingLeft: `${paddingX}px`, paddingRight: `${paddingX}px`, paddingTop: `${paddingY}px`, paddingBottom: `${paddingY}px` }} className={`w-1/2 text-center ${pageType === 'STORE' ? 'rounded-[22px] bg-[#F16878] text-[#FFFFFF]' : 'text-[#7A869A]'}`}>Store on Deals</div>

                <div style={{ paddingLeft: `${paddingX}px`, paddingRight: `${paddingX}px`, paddingTop: `${paddingY}px`, paddingBottom: `${paddingY}px` }} className={`w-1/2 text-center ${pageType === 'ABOUT' ? 'rounded-[22px] bg-[#F16878] text-[#FFFFFF]' : 'text-[#7A869A]'}`}>About us</div>
            </div>
        </div>
    );
}

export default SectionButtons;
